import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Socket from '../Socket';
import Footer from '../components/footer/Footer';
import UpdatePopup from '../components/update popup/UpdatePopup';
import { useSelector } from 'react-redux';
import Sidebar from '../components/sidebar/sidebar';
import Header from '../components/header/Header';

const BaseLayout = () => {

    const [collapsed, setCollapsed] = useState(false);
    const popupData = useSelector((state) => state.popup);

    return (
        <div className={`main-cover d-flex ${collapsed ? "sidebar-collapsed" : ""}`}>

            {/* Sidebar */}
            <Sidebar
                collapsed={collapsed}
                setCollapsed={setCollapsed}
            />

            {/* Right Side Content */}
            <div className="content-area flex-grow-1">

                <Header />

                {popupData && Object.keys(popupData)?.length > 0 && (
                    <UpdatePopup />
                )}

                <Outlet />

                <Footer />

            </div>

            <Socket />

        </div>
    );
};

export default BaseLayout;
